import React from 'react';

const About = () => {
  return (
    <div className="about">
      <section className="section hero-section about-hero">
        <div className="container">
          <h1 className="text-center">About ClinAddis</h1>
          <p className="subtitle text-center">
            Connecting medical professionals through learning, dialogue, and collaboration
          </p>
        </div>
      </section>
      
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ marginBottom: '1rem', color: 'var(--primary)', fontWeight: 'bold' }}>Our Mission</h2>
              <p style={{ fontSize: '1.1rem' }}>Clinaddis exists to connect medical students, professionals, institutions, and partners through learning, 
              dialogue, and collaboration bridging information gaps and strengthening the health ecosystem.</p>
            </div>

            <div style={{ marginBottom: '3rem' }}>
              <h2 style={{ marginBottom: '1rem', color: 'var(--primary)', fontWeight: 'bold' }}>Our Vision</h2>
              <p style={{ fontSize: '1.1rem' }}>To build a connected, informed, and empowered medical community that advances healthcare practice, 
              leadership, and innovation in Ethiopia and beyond.</p>
            </div>

            <div>
              <h2 style={{ marginBottom: '1rem', color: 'var(--primary)', fontWeight: 'bold' }}>Our Story</h2>
              <p style={{ fontSize: '1.1rem' }}>Clinaddis began with a simple observation. Despite the depth of talent within the medical community there were limited spaces for open dialogue shared learning and meaningful connection across disciplines and career stages.
              Medical students professionals educators and innovators often worked in parallel.</p>
              <p>Opportunities to exchange ideas learn from one another and access clear information were limited. Over time these gaps affected professional growth collaboration and system level understanding. Clinaddis emerged in response to this need.
              What started as a small and intentional gathering gradually evolved into a broader platform for exchange collaboration and professional development.</p>
              <p>Clinaddis became a neutral space where ideas could be shared questions explored and partnerships formed without hierarchy or exclusion.
              Today Clinaddis serves as a medical community hub bringing together individuals and institutions who share a commitment to improving healthcare through knowledge dialogue and collective effort. As the community continues to grow Clinaddis remains focused on its core purpose. Strengthening connections and enabling informed participation within the health ecosystem.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;